import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {UserSessionStoreService as StoreService} from '@drl/core/store/user-session-store.service';
import { AppointmentBulk } from '../../appointment-bulk.model';

@Injectable()
export class AppointmentAdapter implements IAdapter<AppointmentBulk> {
  constructor(private readonly store: StoreService) {}

  adaptToModel(resp: AppointmentBulk): AppointmentBulk {
    // Appointment belongs to current user
    return resp;
  }
  // sonarignore:start
  adaptFromModel(data: AppointmentBulk): any {
    data.appointments.forEach((appt)=>{
      delete appt.uniqId;
      delete appt.apptDateTimeString;
      delete appt.patientFullName;
      delete appt.patientMobileNumber;
      delete appt.patientExternalId;
      delete appt.searchBy;
    });
    return data;
  // sonarignore:end
  }
}
